import { Component } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { Layers } from 'src/app/shared/layers-config/layers'

@Component({
  selector: 'app-trip-statistics-data',
  templateUrl: './trip-statistics-data.component.html',
  standalone: false,
})
export class TripStatisticsDataComponent {
  public layerIds = Layers
  public isRoadCoverageLayerVisible: boolean
  public isSpeedProfileLayerVisible: boolean

  constructor(private appState: AppStateService) {
    const layers = this.appState.selectLayers(Layers.RoadCoverage.name)

    if (layers) {
      this.isRoadCoverageLayerVisible = layers?.some((layer) => layer === Layers.RoadCoverage.name)
      this.isSpeedProfileLayerVisible = layers?.some((layer) => layer === Layers.SpeedProfile.name)
    } else {
      this.isRoadCoverageLayerVisible = false
      this.isSpeedProfileLayerVisible = false
    }
    this.updateQueryParameters()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.RoadCoverage.name:
        this.isRoadCoverageLayerVisible = !this.isRoadCoverageLayerVisible
        break
      case Layers.SpeedProfile.name:
        this.isSpeedProfileLayerVisible = !this.isSpeedProfileLayerVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) => !(layer == Layers.RoadCoverage.name) && !(layer == Layers.SpeedProfile.name),
      )

    if (this.isRoadCoverageLayerVisible) {
      layers.push(Layers.RoadCoverage.name)
    }
    if (this.isSpeedProfileLayerVisible) {
      layers.push(Layers.SpeedProfile.name)
    }

    this.appState.setState(AppPaths.Internal, {
      layers: layers?.toString(),
    })
  }

  ngOnInit() {
    const layers = this.appState.selectLayers()
    if (layers) {
      this.isRoadCoverageLayerVisible = layers?.some((layer) => layer === Layers.RoadCoverage.name)
      this.isSpeedProfileLayerVisible = layers?.some((layer) => layer === Layers.SpeedProfile.name)
    } else {
      this.isRoadCoverageLayerVisible = false
      this.isSpeedProfileLayerVisible = false
    }
  }
}
